import { useMediaQuery } from "Hooks/useMediaQuery";
import React from "react";
import styled from "styled-components";

export const ProgressBar = ({ progress }) => {
  const isMobile = useMediaQuery();
  let percentage;
  if (progress === 1) {
    percentage = 100;
  } else {
    percentage = Math.floor(progress * 100);
  }

  const Parentdiv = {
    height: "10px",
    width: "100%",
    backgroundColor: "lightgrey",
    borderRadius: 40,
    margin: "10px 0",
  };

  const Childdiv = {
    height: "10px",
    width: "40vw",
    maxWidth: `430px`,
    background: "linear-gradient(to right, #1b0076,  #e71e3d)",
    borderRadius: 40,
    position: "absolute",
  };

  const ChilddivMobile = {
    height: "10px",
    width: "76vw",
    maxWidth: `940px`,
    background: "linear-gradient(to right, #1b0076,  #e71e3d)",
    borderRadius: 40,
    position: "absolute",
  };

  const PercentContainer = {
    height: "10px",
    width: `${percentage}%`,
    background: "transparent",
    borderRadius: 40,
    overflow: "hidden",
    position: "relative",
  };

  return (
    <Wrapper>
      <div style={Parentdiv}>
        <div style={PercentContainer}>
          <div style={isMobile ? ChilddivMobile : Childdiv}></div>
        </div>
      </div>
      <Percent>
        <p>{percentage}%</p>
      </Percent>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const Percent = styled.div`
  width: 50px;
  p {
    margin: 8px 0px -8px 20px;
    font-size: 14px;
  }
  @media (max-width: 950px) {
    width: 20px;
    font-size: 12px;
    margin-right: 10px;
  }
  @media (min-width: 500px) and (max-width: 950px) {
    p {
      margin: 8px 0px -8px 40px;
      font-size: 15px;
    }
  }
`;
